var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEntitlements(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1420_9165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.3333 48.3333H30V45C30 44.5 29.6667 44.1667 29.1667 44.1667H28.3333V40.6667C33.6667 39.1667 37.5 34.0833 37.5 28.3333C37.5 21.4167 31.9167 15.8333 25 15.8333C18.0833 15.8333 12.5 21.4167 12.5 28.3333C12.5 34.0833 16.3333 39.1667 21.6667 40.6667V44.1667H20.8333C20.3333 44.1667 20 44.5 20 45V48.3333H1.66667V45H0V49.1667C0 49.6667 0.333333 50 0.833333 50H49.1667C49.6667 50 50 49.6667 50 49.1667V39.1667H48.3333V48.3333ZM22.6667 39.1667C17.75 38.0833 14.1667 33.5 14.1667 28.3333C14.1667 22.3333 19 17.5 25 17.5C31 17.5 35.8333 22.3333 35.8333 28.3333C35.8333 33.5 32.25 38.0833 27.3333 39.1667C26.9167 39.25 26.6667 39.5833 26.6667 40V44.1667H23.3333V40C23.3333 39.5833 23.0833 39.25 22.6667 39.1667ZM21.6667 45.8333H22.5H27.5H28.3333V48.3333H21.6667V45.8333Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1667 11.6667H46.6667V8.33333C46.6667 7.83333 46.3333 7.5 45.8333 7.5H23.3333V0.833333C23.3333 0.333333 23 0 22.5 0H0.833333C0.333333 0 0 0.333333 0 0.833333V40H1.66667V21.6667H10.8333V20H1.66667V1.66667H21.6667V8.33333V11.6667H6.66667V13.3333H22.5H45.8333H48.3333V20H39.1667V21.6667H48.3333V34.1667H50V12.5C50 12 49.6667 11.6667 49.1667 11.6667ZM23.3333 11.6667V9.16667H45V11.6667H23.3333Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1666 28.3333C34.1666 23.25 30.0833 19.1667 25 19.1667C19.9166 19.1667 15.8333 23.25 15.8333 28.3333C15.8333 33.4167 19.9166 37.5 25 37.5C30.0833 37.5 34.1666 33.4167 34.1666 28.3333ZM17.5 28.3333C17.5 24.1667 20.8333 20.8333 25 20.8333C29.1666 20.8333 32.5 24.1667 32.5 28.3333C32.5 32.5 29.1666 35.8333 25 35.8333C20.8333 35.8333 17.5 32.5 17.5 28.3333Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83335 3.33333H4.16669V4.99999H5.83335V3.33333Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 3.33333H7.5V4.99999H9.16667V3.33333Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3.33333H10.8333V4.99999H12.5V3.33333Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 3.33333H14.1667V4.99999H15.8334V3.33333Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 3.33333H17.5V4.99999H19.1667V3.33333Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0834 36.0833L37.5 39.6667L35.5834 37.75L34.4167 38.9167L36.9167 41.4167C37.0834 41.5833 37.25 41.6667 37.5 41.6667C37.75 41.6667 37.9167 41.5833 38.0834 41.4167L42 37.5H50V35.8333H41.6667C41.4167 35.8333 41.25 35.9167 41.0834 36.0833Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4167 43.0833L15.5833 38.9167L14.4167 37.75L10.5 41.6667H0V43.3333H10.8333C11.0833 43.3333 11.25 43.25 11.4167 43.0833Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 31.6667C25.5833 31.6667 26.1667 31.5 26.6667 31.1667L28.5833 33.0833L29.75 31.9167L27.8333 30C28.1667 29.5 28.3333 28.9167 28.3333 28.3333C28.3333 26.5 26.8333 25 25 25C23.1667 25 21.6667 26.5 21.6667 28.3333C21.6667 28.9167 21.8333 29.5 22.1667 30L20.25 31.9167L21.4167 33.0833L23.3333 31.1667C23.8333 31.5 24.4167 31.6667 25 31.6667ZM25 26.6667C25.9167 26.6667 26.6667 27.4167 26.6667 28.3333C26.6667 29.25 25.9167 30 25 30C24.0833 30 23.3333 29.25 23.3333 28.3333C23.3333 27.4167 24.0833 26.6667 25 26.6667Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1420_9165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntitlements);
export default __webpack_public_path__ + "static/media/entitlements.97ee17ad1c9630dac96dd97e4de0f983.svg";
export { ForwardRef as ReactComponent };